import Colors from "./Colors"

const getFirstWarningOfLevel = (model, level) => {
  return model?.warnings?.find(item => item.level === level) || null
}

export const gatherModelWarnings = (model) => {
  const results = {
    criticalWarning: getFirstWarningOfLevel(model, 'CRITICAL'),
    errorWarning: getFirstWarningOfLevel(model, 'ERROR'),
    generalWarning: getFirstWarningOfLevel(model, 'WARNING'),
    infoWarning: getFirstWarningOfLevel(model, 'INFO'),
  }

  return {
    ...results,
    anyWarning: Object.values(results).some(Boolean),
  }
}

export const determineTooltipDetails = (result) => {
  if (result.criticalWarning) {
    return {
      color: Colors.orange,
      message: result.criticalWarning.description,
    }
  }
  if (result.errorWarning) {
    return {
      color: Colors.orange,
      message: result.errorWarning.description,
    }
  }

  if (result.generalWarning) {
    return {
      color: Colors.orange,
      message: result.generalWarning.description,
    }
  }

  if (result.infoWarning) {
    return {
      color: Colors.info,
      message: result.infoWarning.description,
    }
  }

  return { color: null, message: null }
}
